<template>
  <div
    v-if="dialog"
    class="modal is-active"
    @keydown.esc="cancel"
    @keydown.enter="agree"
    tabindex="0"
    ref="modal"
  >
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="card">
        <div class="card-content">
          <p class="title">
            {{ title }}
          </p>
          <p class="subtitle">
            {{ message }}
          </p>
          <div class="buttons">
            <button class="button is-primary" @click="agree">Confirm</button>
            <button class="button is-danger" @click="cancel">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="cancel"></button>
  </div>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
  }),
  methods: {
    open(title, message) {
      this.dialog = true;
      this.title = title;
      this.message = message;

      // set focus so modal can be closed with esc key or confirmed with enter
      this.$nextTick(() => this.$refs.modal.focus());

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
